import { DataGrid, DataGridColumn } from '@sl/react-datafabric-components';
import { useState } from 'react';
import { useGetTransactionsQuery } from '../../../../../common/redux/services/transactions';

interface TransactionsDialogProps {}

export default function TransactionsDialog({}: TransactionsDialogProps) {
  const [gridState, setGridState] = useState({
    page: 1,
    rows: 10,
    first: 1,
    filters: {},
  });

  const { data: transactions, isLoading } = useGetTransactionsQuery(gridState);

  const columns: DataGridColumn<any>[] = [
    {
      field: 'createdAt',
      header: 'Date',
      sortable: true,
      type: 'date',
      format: 'dd-MM-yyyy HH:mm:ss',
    },
    {
      field: 'value',
      header: 'Amount',
      sortable: true,
      type: 'currency',
      body: (rowData: any) =>
        Math.abs(
          rowData.value?.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) || 0
        ),
    },
  ];

  const handleGridStateChange = (newGridState: any) => {
    setGridState(newGridState);
  };

  return (
    <DataGrid
      entityLabel='Transactions'
      value={transactions?.data || []}
      columns={columns}
      loading={isLoading}
      totalRecords={transactions?.meta?.itemCount || 0}
      gridState={gridState}
      onFiltersUpdate={handleGridStateChange}
      dateFilter
      globalSearchField='queryString'
      paginator
      size='small'
      dataKey='id'
      cardContainer={false}
      className='px-4'
    />
  );
}
